/**
 * The words of the HR open issues closed in phase 1 of the plan of 2026-10-02 (human-resources
 * #6–#21): kept beside the catalogue, as the other HR rounds' words are, and spread into it.
 */
export const HR_OPEN_ISSUES_EN = {
    // human-resources#11 — a probation that ended with no decision is confirmed by lapse.
    'value.reason_code.lapsed': 'Probation ended with no decision (Art. 53)',
    // Phase 2 of the 2026-10-02 plan (2026-10-03): performance #11/#20, employee documents #9, carry-over and
    // nursing hour #10, government card #13, Ajeer #16, loans #19, self-service #15, payroll finance half #14.
    'value.scope_kind.location': 'A work location',
    'value.stage.open': 'Open',
    'value.stage.following': 'Following',
    'value.stage.closed_improved': 'Closed, improved',
    'value.stage.closed_not_improved': 'Closed, not improved',
    // human-resources#73 (the owner's decision of 2026-10-10): a probation with nobody to rate it.
    'unit.probations.zero': 'No probations',
    'unit.probations.one': '{n} probation',
    'unit.probations.two': '{n} probations',
    'unit.probations.few': '{n} probations',
    'unit.probations.many': '{n} probations',
    'unit.probations.other': '{n} probations',
    'nav.qiwa.ajeer': 'Ajeer permits',
    'gov_sa.qiwa.ajeer.screen.title': 'Ajeer permits',
    'gov_sa.qiwa.ajeer.screen.lede': 'Workers lent out or borrowed in: done on Qiwa, the permit number recorded here and checked by another; borrowed-in work is scheduled only in a checked permit.',
    'gov_sa.qiwa.ajeer.col.employee': 'Worker',
    'gov_sa.qiwa.ajeer.col.direction': 'Direction',
    'gov_sa.qiwa.ajeer.col.other_establishment': 'Other establishment',
    'gov_sa.qiwa.ajeer.col.occupation': 'Occupation',
    'gov_sa.qiwa.ajeer.col.starts_on': 'From',
    'gov_sa.qiwa.ajeer.col.ends_on': 'To',
    'gov_sa.qiwa.ajeer.col.permit_number': 'Permit number',
    'gov_sa.qiwa.ajeer.col.notes': 'Notes',
    'gov_sa.qiwa.ajeer.direction.lent_out': 'Lent out',
    'gov_sa.qiwa.ajeer.direction.borrowed_in': 'Borrowed in',
    'gov_sa.qiwa.ajeer.status.to_do': 'To do on Qiwa',
    'gov_sa.qiwa.ajeer.status.recorded': 'Waiting to be checked',
    'gov_sa.qiwa.ajeer.status.upcoming': 'Not started yet',
    'gov_sa.qiwa.ajeer.status.in_force': 'In force',
    'gov_sa.qiwa.ajeer.status.expired': 'Expired',
    'gov_sa.qiwa.ajeer.status.withdrawn': 'Withdrawn',
    'gov_sa.qiwa.ajeer.stat.expired': 'Expired',
    'gov_sa.qiwa.ajeer.empty': 'No Ajeer permits',
    'gov_sa.qiwa.ajeer.empty.description': 'A worker lent out to another establishment, or borrowed in from one, is recorded here with the days the permit covers.',
    'gov_sa.qiwa.ajeer.action.open': 'New Ajeer permit',
    'gov_sa.qiwa.ajeer.action.open.field.assignment_id.help': "The worker's assignment the permit covers: scheduling holds that work, and only that, to the permit's days.",
    'gov_sa.qiwa.ajeer.field.other_establishment': 'Other establishment number',
    'gov_sa.qiwa.ajeer.field.other_establishment.help': "The establishment's number on the labour platform.",
    'gov_sa.qiwa.ajeer.field.occupation.help': 'As the permit names it on the platform.',
    'gov_sa.qiwa.ajeer.action.record': 'Record the permit number',
    'gov_sa.qiwa.ajeer.action.record.field.reference.help': 'The number the platform gave the permit. Somebody else checks it before it counts.',
    'gov_sa.qiwa.ajeer.action.withdraw': 'Withdraw',
    'gov_sa.qiwa.kind.ajeer_permit': 'Ajeer permit',
    'gov_sa.refusal.qiwa.ajeer_end_before_start': 'The last day is before the first ({starts_on}).',
    'gov_sa.refusal.qiwa.assignment_unknown': 'There is no such assignment for this worker.',
    'gov_sa.refusal.qiwa.ajeer_overlap': 'Another permit for this work already covers some of these days.',
    'value.channel.desk': 'Recorded by HR',
    'value.channel.self_service': 'From self-service',
    'value.kind.general': 'Grievance (not yet classified)',
    'value.kind.incident': 'Incident at work',
    'value.status.carried': 'Carried to the next run',
    'value.result.matches': 'Matches',
    'value.result.differs': 'Differs',
    'value.result.not_posted': 'Not posted yet',
    'value.result.no_code': 'No account code',
    'value.result.no_file': 'No bank file yet',
    'value.level.item': 'Item',
    'value.level.group': 'Group',
    'value.level.net': 'Net pay',
    'value.level.bank': 'Bank file',
    // The HR documents made on doc_templates (2026-10-03): certificate #13, salary letter #14, custody #12,
    // experience letter #19, letter requests #15.
    'value.language.ar': 'Arabic',
    'value.language.en': 'English',
    'value.purpose.bank': 'A bank',
    'value.purpose.embassy': 'An embassy',
    'value.purpose.government': 'A government body',
    'value.purpose.rental': 'A housing or rent provider',
    'value.purpose.other': 'Whom it may concern',
    'value.status.issued': 'Issued',
    'value.status.declined': 'Declined',
    'value.status.withdrawn': 'Withdrawn',
    // Leave approval chain and entitlement matrix #10; three more differences after a lock #14 (2026-10-03).
    'value.entitlement.any': 'Any',
    'value.gender.male': 'Men',
    'value.gender.female': 'Women',
    'value.nationality.saudi': 'Saudi',
    'value.nationality.non_saudi': 'Non-Saudi',
};
export const HR_OPEN_ISSUES_AR = {
    'value.reason_code.lapsed': 'انتهت التجربة بلا قرار (المادة 53)',
    // Phase 2 of the 2026-10-02 plan (2026-10-03): performance #11/#20, employee documents #9, carry-over and
    // nursing hour #10, government card #13, Ajeer #16, loans #19, self-service #15, payroll finance half #14.
    'value.scope_kind.location': 'موقع عمل',
    'value.stage.open': 'مفتوحة',
    'value.stage.following': 'قيد المتابعة',
    'value.stage.closed_improved': 'أُغلقت بنجاح',
    'value.stage.closed_not_improved': 'أُغلقت بلا تحسّن',
    'unit.probations.zero': 'لا فترات تجربة',
    'unit.probations.one': 'فترة تجربة واحدة',
    'unit.probations.two': 'فترتا تجربة',
    'unit.probations.few': '{n} فترات تجربة',
    'unit.probations.many': '{n} فترة تجربة',
    'unit.probations.other': '{n} فترة تجربة',
    'nav.qiwa.ajeer': 'تصاريح أجير',
    'gov_sa.qiwa.ajeer.screen.title': 'تصاريح أجير',
    'gov_sa.qiwa.ajeer.screen.lede': 'عمّال معارون أو مستعارون: يُنجز التصريح في قوى ويُسجَّل رقمه هنا ويتحقّق منه غيرك؛ ولا يُجدول العمل المستعار إلا في تصريح متحقَّق منه.',
    'gov_sa.qiwa.ajeer.col.employee': 'العامل',
    'gov_sa.qiwa.ajeer.col.direction': 'الاتجاه',
    'gov_sa.qiwa.ajeer.col.other_establishment': 'المنشأة الأخرى',
    'gov_sa.qiwa.ajeer.col.occupation': 'المهنة',
    'gov_sa.qiwa.ajeer.col.starts_on': 'من',
    'gov_sa.qiwa.ajeer.col.ends_on': 'إلى',
    'gov_sa.qiwa.ajeer.col.permit_number': 'رقم التصريح',
    'gov_sa.qiwa.ajeer.col.notes': 'ملاحظات',
    'gov_sa.qiwa.ajeer.direction.lent_out': 'معار لمنشأة أخرى',
    'gov_sa.qiwa.ajeer.direction.borrowed_in': 'مستعار من منشأة أخرى',
    'gov_sa.qiwa.ajeer.status.to_do': 'يُنجز في قوى',
    'gov_sa.qiwa.ajeer.status.recorded': 'بانتظار التحقّق',
    'gov_sa.qiwa.ajeer.status.upcoming': 'لم يبدأ بعد',
    'gov_sa.qiwa.ajeer.status.in_force': 'سارٍ',
    'gov_sa.qiwa.ajeer.status.expired': 'منتهٍ',
    'gov_sa.qiwa.ajeer.status.withdrawn': 'مسحوب',
    'gov_sa.qiwa.ajeer.stat.expired': 'منتهية',
    'gov_sa.qiwa.ajeer.empty': 'لا تصاريح أجير',
    'gov_sa.qiwa.ajeer.empty.description': 'العامل المعار لمنشأة أخرى أو المستعار منها يُسجَّل هنا مع الأيام التي يغطّيها التصريح.',
    'gov_sa.qiwa.ajeer.action.open': 'تصريح أجير جديد',
    'gov_sa.qiwa.ajeer.action.open.field.assignment_id.help': 'تكليف العامل الذي يغطّيه التصريح: تقصر الجدولة ذلك العمل وحده على أيام التصريح.',
    'gov_sa.qiwa.ajeer.field.other_establishment': 'رقم المنشأة الأخرى',
    'gov_sa.qiwa.ajeer.field.other_establishment.help': 'رقم المنشأة في منصّة العمل.',
    'gov_sa.qiwa.ajeer.field.occupation.help': 'كما يسمّيها التصريح في المنصّة.',
    'gov_sa.qiwa.ajeer.action.record': 'تسجيل رقم التصريح',
    'gov_sa.qiwa.ajeer.action.record.field.reference.help': 'الرقم الذي أعطته المنصّة للتصريح. يتحقّق منه شخص آخر قبل أن يُعتدّ به.',
    'gov_sa.qiwa.ajeer.action.withdraw': 'سحب',
    'gov_sa.qiwa.kind.ajeer_permit': 'تصريح أجير',
    'gov_sa.refusal.qiwa.ajeer_end_before_start': 'اليوم الأخير قبل الأول ({starts_on}).',
    'gov_sa.refusal.qiwa.assignment_unknown': 'لا يوجد هذا التكليف لهذا العامل.',
    'gov_sa.refusal.qiwa.ajeer_overlap': 'تصريح آخر لهذا العمل يغطّي بعض هذه الأيام.',
    'value.channel.desk': 'سجّلته الموارد البشرية',
    'value.channel.self_service': 'من الخدمة الذاتية',
    'value.kind.general': 'تظلّم (لم يُصنَّف بعد)',
    'value.kind.incident': 'حادثة عمل',
    'value.status.carried': 'مرحّل إلى المسيّر التالي',
    'value.result.matches': 'مطابق',
    'value.result.differs': 'مختلف',
    'value.result.not_posted': 'لم يُرحَّل بعد',
    'value.result.no_code': 'بلا رمز حساب',
    'value.result.no_file': 'لا ملف بنك بعد',
    'value.level.item': 'بند',
    'value.level.group': 'مجموعة',
    'value.level.net': 'الصافي',
    'value.level.bank': 'ملف البنك',
    // The HR documents made on doc_templates (2026-10-03): certificate #13, salary letter #14, custody #12,
    // experience letter #19, letter requests #15.
    'value.language.ar': 'العربية',
    'value.language.en': 'الإنجليزية',
    'value.purpose.bank': 'جهة مصرفية',
    'value.purpose.embassy': 'سفارة',
    'value.purpose.government': 'جهة حكومية',
    'value.purpose.rental': 'جهة تأجير',
    'value.purpose.other': 'من يهمّه الأمر',
    'value.status.issued': 'صدر',
    'value.status.declined': 'مُعتذَر عنه',
    'value.status.withdrawn': 'مسحوب',
    // Leave approval chain and entitlement matrix #10; three more differences after a lock #14 (2026-10-03).
    'value.entitlement.any': 'أيّ',
    'value.gender.male': 'الرجال',
    'value.gender.female': 'النساء',
    'value.nationality.saudi': 'سعودي',
    'value.nationality.non_saudi': 'غير سعودي',
};
//# sourceMappingURL=i18n-hr-open-issues.js.map